import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Paper,
    Typography,
    useTheme,
} from "@mui/material";
import { useState } from "react";
import { getFileIcon } from "../../Utils/handler";
import CloseIcon from "@mui/icons-material/Close";
import DocPreview from "./DocPreview";
import { BucketURL } from "../../ApiSetup/Api";
import { getImageUrl as getImageUrlUtil } from "../../Utils/handler";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
export const DocWithPreview = ({
    docArray = [],
    src = "",
    docName = "",
    canEdit = false,
    width = "",
    height = "",
    maxWidth = "",
    title = "",
}) => {
    // Ensure docArray is always an array - handle string input
    let orignalDocArray = docArray;
    if (typeof docArray === 'string') {
        docArray = docArray ? [docArray] : [];
        orignalDocArray = docArray;
    }
    if (!Array.isArray(docArray)) {
        docArray = [];
        orignalDocArray = [];
    }
    
    // Debug: log incoming docArray
    console.log('[DocWithPreview] Input docArray:', docArray, 'title:', title);
    
    docArray = docArray.filter(file => file).map((file, index) => ({
        fileUrl: getImageUrlUtil(file),
        fileName: `${title}${index + 1}`,
    }));
    
    console.log('[DocWithPreview] Processed docArray:', docArray);

    src = docArray.length > 0 ? docArray[0].fileUrl : "";
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const [currIndex, setCurrIndex] = useState(0);
    const [rotation, setRotation] = useState(0);
    const icon = getFileIcon(orignalDocArray, docArray[currIndex]?.fileName)
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleRotate = () => {
        setRotation((prev) => (prev + 90) % 360); // Rotate by 90 degrees
    };

    const handleDownload = () => {
        fetch(docArray[currIndex].fileUrl)
            .then((response) => response.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", docArray[currIndex].fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            })
            .catch((error) => {
                console.error("Error downloading file:", error);
            });
    };

    // const handleDownload = (imageUrl) => {
    //     const proxyUrl = 'https://api.allorigins.win/get?url=';
    //     fetch(`${proxyUrl}${encodeURIComponent(imageUrl)}`)
    //         .then(response => response.json())
    //         .then(data => {
    //             const binaryString = atob(data.contents.split(',')[1]);
    //             const len = binaryString.length;
    //             const bytes = new Uint8Array(len);
    //             for (let i = 0; i < len; i++) {
    //                 bytes[i] = binaryString.charCodeAt(i);
    //             }
    //             const blob = new Blob([bytes], { type: 'image/png' });
    //             const url = URL.createObjectURL(blob);
    //             const link = document.createElement('a');
    //             link.href = url;
    //             link.download = 'downloaded_image.png';
    //             document.body.appendChild(link);
    //             link.click();
    //             document.body.removeChild(link);
    //             URL.revokeObjectURL(url);
    //         })
    //         .catch(error => {
    //             console.error('Image download failed:', error);
    //         });
    // }

    return (
        <>
            <Paper
                sx={{
                    backgroundColor: (theme) => theme.palette.action.hover,
                    cursor: "pointer",
                }}
                onClick={docArray[currIndex]?.fileUrl && handleClickOpen}
            >
                <Box
                    sx={{ backgroundImage: src ? `url(${src})` : null, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center", }}
                    width={width || "100%"}
                    height={height || "176px"}
                >
                    {icon != "pdf" ? !src && (
                        <Box display="flex" alignItems="center" justifyContent="center" height="100%">
                            <Typography color="textSecondary">No File Uploaded</Typography>
                        </Box>
                    ) : <Box display="flex" alignItems="center" justifyContent="center" height="100%">
                        <Box display={'flex'} justifyContent={'center'} alignItems="center" flexDirection={'column'} gap={1}>
                            <PictureAsPdfIcon fontSize="large" color="primary" />
                            <Typography color="primary" variant="body2">Please click to preview</Typography>
                        </Box>

                    </Box>}
                </Box>
                <Box
                    display="flex"
                    flexWrap="wrap"
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    bgcolor={theme.palette.info.main}
                    mb={"10px"}
                >
                    {docName && (
                        <Typography fontWeight="normal" color="white" marginLeft={1}>
                            {docName}
                        </Typography>
                    )}
                    <Typography fontSize={"0.8rem"} marginRight={2} color="white">
                        {docArray.length > 1 ? "+" + (docArray.length - 1) + " items" : ""}
                    </Typography>
                </Box>
            </Paper>
            {open && (
                <Dialog open={open} onClose={handleClose} fullWidth={true} >
                    <DialogTitle sx={{ padding: "8px 16px" }}>
                        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                            <Typography fontSize={"15px"} fontWeight={700} color={theme.palette.primary.main}>
                                {docName}
                            </Typography>
                            <Box display={"flex"} gap={1} justifyContent={"space-between"} alignItems={"center"}>
                                <IconButton onClick={handleRotate}>
                                    <RotateLeftIcon />
                                </IconButton>
                                <a
                                    href={docArray[currIndex]?.fileUrl}
                                    style={{
                                        float: 'right',
                                        textDecoration: 'none',
                                        fontSize: '16px',
                                        // margin: '4px 4px 0 0',
                                        color: theme.palette.primary.main,
                                    }}
                                    download
                                    onClick={() => handleDownload(docArray[currIndex]?.fileUrl)}
                                    target="_blank"
                                >
                                    Download
                                </a>
                                {/* <Button onClick={() => handleDownload(docArray[currIndex]?.fileUrl)} > */}

                                {/* Download */}
                                {/* </Button> */}
                                <CloseIcon onClick={handleClose} style={{ cursor: "pointer" }} />
                            </Box>
                        </Box>
                    </DialogTitle>

                    <DialogContent
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            overflow: "auto", // Enables scrolling in both directions
                            maxHeight: "100vh", // Restricts vertical height to a maximum
                            maxWidth: "100vw",  // Restricts horizontal width to a maximum
                        }}  >
                        <Box
                            sx={{
                                transform: `rotate(${rotation}deg)`,
                                transition: "transform 0.3s ease",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "auto", // Adjust as needed    
                                overflow: "auto", // Enables scrolling in both directions
                                maxHeight: "100vh", // Restricts vertical height to a maximum
                                maxWidth: "100vw",
                            }}
                        >
                            <DocPreview
                                link={docArray[currIndex]?.fileUrl}
                                iconName={getFileIcon(orignalDocArray, docArray[currIndex]?.fileName)}
                                octateFile={false}
                            />
                        </Box>
                    </DialogContent>

                    {docArray && docArray.length > 1 ? (
                        <DialogActions>
                            <Button
                                variant='outlined'
                                sx={{ borderRadius: "30px" }}
                                autoFocus
                                disabled={currIndex == 0 ? true : false}
                                onClick={() => {
                                    setCurrIndex((val) => val - 1);
                                }}
                            >
                                Previous
                            </Button>
                            <Button
                                variant='outlined'
                                sx={{ borderRadius: "30px" }}
                                disabled={currIndex == docArray.length - 1 ? true : false}
                                onClick={() => {
                                    setCurrIndex((val) => val + 1);
                                }}
                                autoFocus
                            >
                                Next
                            </Button>
                        </DialogActions>
                    ) : (
                        ""
                    )}
                </Dialog >
            )}
        </>
    );
};
